import { PAGE_VIEW } from '../constants';
const resetDataLayer = () => {
  if (!shouldReset()) return false;
  window.dataLayer.length = 0;
  const gtmIdRegex = /GTM-/i;
  const keys = Object.keys(window.google_tag_manager);
  const GTMkeys = keys.filter(key => gtmIdRegex.test(key) && window.google_tag_manager[key].dataLayer);
  GTMkeys.forEach(GTMkey => window.google_tag_manager[GTMkey].dataLayer.reset());
  return true;
};
function shouldReset() {
  return window.google_tag_manager && window.dataLayer && window.dataLayer.find(({
    event
  }) => event === PAGE_VIEW);
}
export default resetDataLayer;
//# sourceMappingURL=reset-data-layer.js.map